import clsx from 'clsx';
import { h } from 'preact';
import { useEffect } from 'preact/hooks';
import { useThreekit } from '../threekit-context';
import { useModal } from '../modal-context';

function BackgroundSelector() {
  const { backgroundColor, setBackgroundColor, getAvailableBackgroundColors } = useThreekit();
  const { modalName } = useModal();

  const backgroundColors = getAvailableBackgroundColors();

  useEffect(() => {
    if (backgroundColor) return;

    setBackgroundColor(backgroundColors.find((color) => color.default));
  }, [backgroundColors, backgroundColor, setBackgroundColor]);

  return (
    <div
      className={clsx(
        'fixed bottom-[calc(50vh+40px)] laptop:bottom-1/2 -translate-y-1/2 left-[10px] laptop:left-[20px]',
        {
          'hidden laptop:block': modalName === 'Compare Materials',
        },
      )}
    >
      <div className="bg-primary-1 bg-opacity-20 rounded-[100px] w-[29px] flex flex-col items-center py-[3px] gap-1">
        {backgroundColors.map((color) => (
          <button
            style={{ backgroundColor: color.hex }}
            type="button"
            key={color}
            onClick={() => setBackgroundColor(color)}
            className={clsx(
              'rounded-full w-[19px] h-[19px] border-[2px] border-transparent ring-white bg-clip-padding m-[1px] transition-all duration-500 ease-in-out',
              {
                'ring-1': backgroundColor?.hex === color.hex,
              },
            )}
          />
        ))}
      </div>
    </div>
  );
}

export default BackgroundSelector;
